import type { ForeignKeyConfig } from "@/components/shared/UniversalCRMTable/types";

/**
 * Canonical foreign-key map for Hub entities.
 * Source: Supabase production MCP (information_schema), deduped per table.column.
 */
export const HUB_FOREIGN_KEY_MAP: Record<string, ForeignKeyConfig> = {
  "app_users.role_id": {
    referencedTable: "roles",
    referencedColumn: "id",
    constraintName: "app_users_role_id_fkey",
    onDelete: "RESTRICT",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "communications.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "communications_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "communications.contact_id": {
    referencedTable: "contacts",
    referencedColumn: "id",
    constraintName: "communications_contact_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "communications.type_id": {
    referencedTable: "communication_types",
    referencedColumn: "id",
    constraintName: "communications_type_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contact_tasks.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "contact_tasks_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contact_tasks.contact_id": {
    referencedTable: "contacts",
    referencedColumn: "id",
    constraintName: "contact_tasks_contact_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contact_tasks.user_id": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "contact_tasks_user_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contacts.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "contacts_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contacts.created_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "contacts_created_by_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "contacts.updated_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "contacts_updated_by_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "deals.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "deals_company_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "msp_documents.client_id": {
    referencedTable: "contacts",
    referencedColumn: "id",
    constraintName: "msp_documents_client_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "msp_documents.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "msp_documents_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "msp_documents.created_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "fk_msp_documents_created_by",
    onDelete: "RESTRICT",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "msp_documents.updated_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "fk_msp_documents_updated_by",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "offerings.created_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "offerings_created_by_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "recurring_transactions.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "recurring_transactions_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "recurring_transactions.customer_id": {
    referencedTable: "contacts",
    referencedColumn: "id",
    constraintName: "recurring_transactions_customer_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "tickets.assigned_to": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "fk_tickets_assigned_to",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "tickets.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "tickets_company_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "tickets.contact_id": {
    referencedTable: "contacts",
    referencedColumn: "id",
    constraintName: "tickets_contact_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "tickets.created_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "fk_tickets_created_by",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "time_entries.approved_by": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "time_entries_approved_by_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "time_entries.company_id": {
    referencedTable: "companies",
    referencedColumn: "id",
    constraintName: "time_entries_company_id_fkey",
    onDelete: "NO ACTION",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "time_entries.ticket_id": {
    referencedTable: "tickets",
    referencedColumn: "id",
    constraintName: "time_entries_ticket_id_fkey",
    onDelete: "SET NULL",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
  "time_entries.user_id": {
    referencedTable: "app_users",
    referencedColumn: "id",
    constraintName: "time_entries_user_id_fkey",
    onDelete: "CASCADE",
    onUpdate: "NO ACTION",
    relationKind: "many-to-one",
  },
};

export const getForeignKeyForField = (tableName: string, fieldId: string): ForeignKeyConfig | undefined =>
  HUB_FOREIGN_KEY_MAP[`${tableName}.${fieldId}`];
